export const BUYBACK_QUOTES_FETCH_INTERVAL = 300

export const BUYBACK_QUOTES_FETCH_TIMEOUT = 5000
